import Vue from "vue/dist/vue.common";
import Vuex from "vuex";
import checkout from "./modules/checkout";
import delivery from "./modules/delivery";
import customer from "./modules/customer";
import payment from "./modules/payment";
import comment from "./modules/comment";
import summary from "./modules/summary";

export function createStore() {
    Vue.use(Vuex);
    return new Vuex.Store({
        modules: {
            checkout,
            delivery,
            customer,
            payment,
            comment,
            summary
        }
    });
}